module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-first"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0178ef56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Hero.vue
// module id = 44
// module chunks = 0